export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-5-960-a0e5bf5dc5d2bb7e04fb41e1ccc73803.png";